export const AppError = {
    InvalidToken: 1020,
    ExpiredToken: 1036,
    UNAUTHORIZED: 401
};